/* file description */
import React from 'react';
import { Popconfirm, Space, message } from 'antd';
import type { UseOptionColumnsProp } from './type';
import { ButtonLayout } from '@/asset/AssetTask/templates/Cascade/components';
import RuleController from '@/components/RuleController';

export const useOptionColumns: UseOptionColumnsProp = ({
  fileModule,
  optionColumns,
  // mergeAutoRowEditConfig,
  mergeRowKey,
  addEditRecord,
  rowCopyable,
  rowDelable,
  editableRef,
  mode,
  fileFieldMap,
  rowsData,
  setRowsData,
  setPreviewProps,
  onChange,
  moduleInfo,
}) => {
  const moduleID = moduleInfo?.handle;
  const primaryFields = moduleInfo?.fields?.filter((x) => x.isPrimary) || [];
  if (optionColumns === false) {
    return null;
  }

  const render = (text: string, record: any, index: number, rowIndex: number) => {
    let btns = [];
    // 非文件模型
    if (!fileModule) {
      // 非编辑态
      if (mode !== 'view') {
        rowCopyable && btns.push(
          <RuleController id={`${moduleID}.row-copy-btns`}>
            <ButtonLayout
              type="link"
              key="copy"
              onClick={() => {
                const newRecord = {
                  ...record,
                  RECORD: null,
                };
                for (const f of primaryFields) {
                  delete newRecord[f.name];
                }
                addEditRecord(newRecord);
              }}
            >
              复制
            </ButtonLayout>
          </RuleController>,
        );
        rowDelable && btns.push(
          <RuleController id={`${moduleID}.row-delete-btns`}>
            <ButtonLayout
              type="link"
              onClick={() => {
                editableRef.current.removeRow(rowIndex);
              }}
            >
              删除
            </ButtonLayout>
          </RuleController>,
        );
      }
    } else {
      const url = fileFieldMap?.find((item: any) => item.value === 'url')?.name || 'url';
      let fileType = '';
      let fileName = '';
      if (record?.[url]) {
        const arr = record[url].split('.');
        const chatList = record[url].split('/');
        fileType = arr[arr.length - 1];
        fileName = chatList[chatList.length - 1];
      }
      btns.push(
        <ButtonLayout
          type="link"
          key="editable"
          onClick={() => {
            if (record[url]) {
              const link = document.createElement('a');
              link.href = record[url];
              link.download = fileName;
              link.click();
              link.remove();
              // window.open(record[url]);
            } else {
              message.error('该文件地址不存在');
            }
          }}
        >
          下载
        </ButtonLayout>,
      );
      (mode !== 'view' && rowDelable) &&
        btns.push(
          <Popconfirm
            key="delete"
            title="确认要删除这一项吗?"
            onConfirm={async () => {
              editableRef.current.removeRow(index);
            }}
            okText="确认"
            cancelText="取消"
          >
            <ButtonLayout type="link">删除</ButtonLayout>
          </Popconfirm>,
        );
      (mode === 'view' && ['png', 'jpg', 'jpeg', 'pdf'].includes(fileType)) &&
        btns.push(
          <ButtonLayout
            type="link"
            key="preview"
            onClick={() => {
              setPreviewProps({ visible: true, previewUrl: record[url], fileType });
            }}
          >
            预览
          </ButtonLayout>,
        );
    }
    const optionsBtns = optionColumns && optionColumns?.render(text, record, index, rowIndex);
    btns = btns.concat(optionsBtns || []);
    btns = btns.filter((x) => !!x);
    return (
      <Space>{btns}</Space>
    );
  };

  return {
    title: '操作',
    valueType: 'option',
    key: 'option',
    fixed: 'right',
    align: 'center',
    render,
  };
};
